<div [formGroup]="phoneNumberForm">
  @if (!loadingService.loading()) {
    <label class="col-span-12 mb-8 text-18">
      {{ label() | translate }}
      <span class="text-primary-dark relative -top-12">*</span>
    </label>
  }
  <div
    class="relative"
    [class.col-span-12]="loadingService.loading()"
    [class.col-span-9]="!loadingService.loading()">
    <div class="col-span-3 mt-6 absolute ltr:-left-6 rtl:-right-6 top-7 z-10">
      <pwj-select-dropdown
        hasSearch
        formControlName="prefix"
        hasCountryFlag
        [options]="countryCodes"></pwj-select-dropdown>
    </div>
    <pwj-input
      icon="null-space"
      formControlName="mobile_number"
      [placeholder]="placeholder()"
      [subLabel]="subLabel()"
      pwjOnlyNumber
      [messages]="{
        required: 'requires.phoneNumber',
        invalidMobile: 'requires.invalidMobile',
      }"></pwj-input>
  </div>
</div>
